<template>
  <div
    style="
      background: url('https://admin-assets.public-pr50.goldcast.io/assets/bg-gradient.png');
      background-size: cover;
      background-position: center;
    "
    class="tw-w-full"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-px-4 tw-pb-6 tw-pt-20 tw-text-center">
      <h1 class="tw-text-xl tw-text-white sm:tw-text-2xl md:tw-text-4xl">
        <slot name="title">Lights, camera, action!</slot>
      </h1>
      <p class="tw-mt-2 tw-max-w-md tw-text-white">
        <slot name="content" />
      </p>
    </div>
    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-pb-20">
      <slot name="cta" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioEmptyState'
});
</script>
